import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-currency",
  "use": "icon-icon-currency-usage",
  "viewBox": "0 0 11.9 11.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.9 11.9\" id=\"icon-icon-currency\"><defs><style>#icon-icon-currency .cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;}</style></defs><title>资源 1</title><g id=\"icon-icon-currency_图层_2\" data-name=\"图层 2\"><g id=\"icon-icon-currency_图层_1-2\" data-name=\"图层 1\"><line class=\"cls-1\" x1=\"4.2\" y1=\"3.6\" x2=\"5.4\" y2=\"5.1\" /><line class=\"cls-1\" x1=\"7.7\" y1=\"3.6\" x2=\"6.5\" y2=\"5.1\" /><line class=\"cls-1\" x1=\"3.9\" y1=\"5.2\" x2=\"8\" y2=\"5.2\" /><line class=\"cls-1\" x1=\"3.9\" y1=\"7.2\" x2=\"8\" y2=\"7.2\" /><line class=\"cls-1\" x1=\"6\" y1=\"5.2\" x2=\"6\" y2=\"8.7\" /><circle class=\"cls-1\" cx=\"6\" cy=\"6\" r=\"5.5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-currency.svg
// module id = t1oj
// module chunks = 60